import { Session } from "sip.js";

interface IState {
    sessions: Array<Session>,
    activeSession: number | null,
    extraHeaders: {[key: string]: string},
    maxSessions: number
}

const state : IState = {
    // Which session is currently active. 
    sessions: [],
    activeSession: null,
    extraHeaders: {},
    maxSessions: 1,
}

export default {
    namespaced: true,
    state,
    getters: {
        session: (state: IState) => state.activeSession !== null ? state.sessions[state.activeSession] : null,
    },
    mutations: {
        activateSession: (state: IState, session: Session) => {
            // TODO: previous session on hold if it was un-held
            state.activeSession = state.sessions.indexOf(session)
            // TODO: new session un-held if it was held
        },
        addSession: (state: IState, session: Session) => state.sessions.push(session),
        delSession: (state: IState, session: Session) => {
            let idx : number;
            while (-1 !== (idx = state.sessions.indexOf(session))) {
                if (state.activeSession === idx) { state.activeSession = null; }
                else if (typeof state.activeSession === 'number' && state.activeSession > idx) state.activeSession--;
                state.sessions.splice(idx, 1)
            }
        },
        addExtraHeaders: (state: IState, headers: {[key: string]: string}) => state.extraHeaders = {...state.extraHeaders, ...headers},
        setExtraHeaders: (state: IState, headers: {[key: string]: string}) => state.extraHeaders = headers,
        forceSessionsUpdate: (state: IState) => state.sessions = [...state.sessions],
    },
    actions: {},
}